import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Params, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';

import { allAreas, AppState, ConfigService, ResourceService } from '@assist/shared/data';
import { AssistResourceBM } from '@cue/api';
import { CustomUnsafeSanitizePipe } from '@cue/security';
import { NavigationDetailInfo } from '@cue/navigation-services';
import { PoiComponent } from '@cue/poi';
import { translation } from '@cue/translations';
import { FileGalleryComponent } from '@cue/ui/file-gallery';
import { cueArrowRight, cueCheck, cueClose, cueQrCode, IconComponent } from '@cue/ui/icons';
import { WorkingHoursComponent } from '@cue/ui';
import { ImageWidthPipe, LocalizedStringPipe } from '@cue/utilities';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

import { MultiviewRenewAnonymousDetailComponent } from '../multiview-renew-anonymous-detail/multiview-renew-anonymous-detail.component';

@Component({
  selector: 'assist-multiview-renew-detail-resource',
  imports: [
    IconComponent,
    WorkingHoursComponent,
    FileGalleryComponent,
    CustomUnsafeSanitizePipe,
    LocalizedStringPipe,
    TranslocoPipe,
    ImageWidthPipe,
    PoiComponent,
    RouterLink,
    MultiviewRenewAnonymousDetailComponent,
  ],
  templateUrl: './multiview-renew-detail-resource.component.html',
  styleUrl: './multiview-renew-detail-resource.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.navigation-detail]': 'anonymous() || !resource()',
  },
})
export class MultiviewRenewDetailResourceComponent {
  protected readonly ICONS = {
    cueArrowRight,
    cueCheck,
    cueClose,
    cueQrCode,
  };
  protected readonly translation = translation;

  readonly resource = input<AssistResourceBM | null>(null);
  readonly serverDetail = input<NavigationDetailInfo | null>(null);
  readonly anonymous = input(false);

  private readonly store = inject(Store<AppState>);
  protected readonly configService = inject(ConfigService);
  protected readonly translocoService = inject(TranslocoService);
  private readonly resourceService = inject(ResourceService);
  private readonly areas = toSignal(this.store.select(allAreas()));

  protected readonly breadcrumb = computed(() => {
    const resource = this.resource();
    if (!resource) {
      return [];
    }
    const areas = this.areas()?.data ?? [];
    return this.resourceService.getBreadcrumbForResourceInstant(resource, areas);
  });

  protected qrQueryParams(qrCodeId: string): Params {
    return {
      multiviewQr: qrCodeId,
      multiviewResource: null,
    };
  }
}
